export const shortenWecomId = (value) => {
  const text = value == null || value === '' ? '-' : String(value);
  if (text.length <= 18) return text;
  return `${text.slice(0, 8)}…${text.slice(-6)}`;
};

export const mergeOlderLogs = (current, older) => {
  const byId = new Map();
  [...(current || []), ...(older || [])].forEach((log) => {
    if (log && log.id != null && !byId.has(log.id)) {
      byId.set(log.id, log);
    }
  });
  return Array.from(byId.values()).sort((left, right) => right.id - left.id);
};

export const getTimelineEntryKind = (log) => {
  if (log?.status === 'failed' || log?.direction === 'error') return 'error';
  if (log?.direction === 'action') return 'action';
  if (log?.direction === 'outgoing') return 'outgoing';
  return 'incoming';
};

export const getTimelineEntryContent = (log) => {
  if (log?.status === 'failed' || log?.direction === 'error') {
    return '本次处理失败';
  }
  return (
    log?.reply_text
    || log?.message_text
    || log?.action_type
    || log?.intent
    || log?.issue_key
    || '无内容'
  );
};

export const getTimelineTechnicalDetails = (log) => {
  const payload = log?.payload;
  const failureStage = payload && typeof payload === 'object'
    ? payload.failure_stage
    : null;
  const details = {};

  if (log?.error_message) details.error_message = log.error_message;
  if (failureStage) details.failure_stage = failureStage;
  if (payload != null) details.payload = payload;

  return Object.keys(details).length > 0 ? details : null;
};
